<template>
  <div>
    <!--    기본정보-->
    <field-select-module v-model="form.stdInfo" :options="[
        { type: 'date', label: '점검일'},
        { type: 'text', label: '점검장소'},
        { type: 'disaster', label: '재해형태'},
        { type: 'alert', label: '알림 대상자 선택' },
      ]" :board="this.board" :is-print="isPrint"/>

    <!--    장비정보-->
    <table-equipment
      class="mt-5"
      :list="form.equipmentList"
      @updateList="updateList"
      :isPrint="isPrint"
      :isReadonly="board.readonly"
    ></table-equipment>


    <!--    점검대상-->
<!--    <vs-row class="mt-6">-->
<!--      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">-->
<!--        <h5>-->
<!--          <i class="dot"></i> 점검대상-->
<!--        </h5>-->
<!--      </vs-col>-->
<!--    </vs-row>-->

<!--    <div class="gap-x-6 gap-y-4 mt-4">-->
<!--      <span v-if="isPrint"> {{form.inspectionTitle}} </span>-->
<!--      <div class="ml-group-checkBox flex flex-wrap w-full flex-1" v-else>-->
<!--        <vs-checkbox-->
<!--          class="mr-1 mb-2"-->
<!--          :readonly="board.readonly">-->
<!--          {{form.inspectionTitle}}-->
<!--        </vs-checkbox>-->
<!--      </div>-->
<!--    </div>-->


    <table-inspect
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :title="form.inspectionTitle"
      :list="form.inspectList"
      @update-list-check="updateListCheck"
    />


    <!--    사진대지-->
    <PhotoUploadGridModule
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="신축현장 점검"
    />

    <!--    파일첨부-->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>

  </div>
</template>

<script>
import PopupPlanProject from '@/views/project/popup/PopupPlanProject'
import DateSelector from '@/components/selector/DateSelector'
import PopupProjectSetting from '@/views/project/PopupProjectSetting'
import MemberSelector from '@/components/selector/MemberSelector'
import CompanySelector from '@/components/selector/CompanySelector'
import FileUploader from '@/components/FileUploader'
import FileUploadModule from '@/views/modules/FileUploadModule'
import TableInspect from '@/components/TableInspect'
import TableEquipment from '@/components/TableEquipment'
import DisasterClassSelector from '@/components/selector/DisasterClassSelector'
import FieldSelectModule from '@/views/modules/FieldSelectModule'
import PhotoUploadGridModule from '@/views/modules/PhotoUploadGridModule'

export default {
  components: {
    FileUploadModule,
    TableInspect,
    TableEquipment,
    DisasterClassSelector,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    FieldSelectModule,
    PhotoUploadGridModule
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler (value) {
        const keys = Object.keys(this.form)
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key]
          }
        }

        this.form.inspectionTitle = this.inspectionTitle
        if (!this.form || !this.form.inspectList || this.form.inspectList.length === 0) {
          this.form.inspectList = this.inspectTable
        }
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler (value) {
        this.$emit('input', value)
      }
    }
  },
  data () {
    return {

      inspectionTitle:'화기·용접작업',
      form: {
        inspectionTitle:'화기·용접작업',
        stdInfo: { },
        photoList: [],
        fileList: [],
        equipmentList: [],
        inspectList: []
      },
    }
  },
  computed: {
    inspectTable () {
      return [
        {
          id: 1,
          label: '발생하는 화염 또는 스파크 등이 인근 공정설비에 영향이 있다고 판단되는 범위의 지역을 작업구역으로 표시하였다.',
          is_checked: ''
        },
        {
          id: 2,
          label: '화기·용접작업 장소에 근로자의 통행·출입을 제한한다.',
          is_checked: ''
        },
        {
          id: 3,
          label: '화기작업 전에 작업 대상기기 및 작업구역 내에서 인화성 물질 및 독성 물질의 가스 농도를 측정하여 허가서에 기록한다.',
          is_checked: ''
        },
        {
          id: 4,
          label: '불꽃을 발생하는 내연설비의 장비나 차량 등은 작업구역 내 근로자의 출입을 통제한다.',
          is_checked: ''
        },
        {
          id: 5,
          label: '화기작업을 수행하기 위하여 밸브를 차단하거나 맹판을 설치할 때에는 차단하는 밸브에 밸브 잠금 표지 및 맹판 설치 표지를 부착한다.',
          is_checked: ''
        },
        {
          id: 6,
          label: '화학설비 등의 내부에서 화기작업을 수행할 경우에는 배관 및 설비 내의 위험물질을 완전히 비우고 세정한 후에 작업을 수행하고 있다.',
          is_checked: ''
        },
        {
          id: 7,
          label: '밀폐(제한)공간에서의 작업을 수행할 때에는 작업 전에 밀폐공간 내의 공기를 외부의 신선한 공기로 충분히 치환하는 등의 조치(강제 환기 등) 실시한다.',
          is_checked: ''
        },
        {
          id: 8,
          label: '용접불티 비산방지 덮개 또는 용접 방화포 등 불꽃 비산 방지조치를 하고 개방된 맨홀과 하수구(Sewer) 등은 덮거나 닫는다.',
          is_checked: ''
        },
        {
          id: 9,
          label: '화재감시자를 지정하여 화기작업을 시작하기 전과 작업 도중 안전 상태를 확인하도록 한다.',
          is_checked: ''
        },
        {
          id: 10,
          label: '작업 중에 수시로 가스 농도를 측정한다.(분진이 있는 장소는 분진농도를 추가로 측정)',
          is_checked: ''
        },
        {
          id: 11,
          label: '화기작업 전에 이동식 소화기 등을 비치한다.',
          is_checked: ''
        },
        {
          id: 12,
          label: '위 안전조치가 모두 조치되었음을 확인한 후에 작업을 시작하도록 관리한다.',
          is_checked: ''
        },
      ]
    },
  },
  methods : {
    updateList (list) {
      this.form.equipmentList = list
    },
    updateListCheck (indexRows, text) {
      this.form.inspectList[indexRows].is_checked = text
    },
  }
}
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}
.upload-content {
  border: $border;
  &:last-child {
    border-left: none;
  }
  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }
  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
</style>
